import React, { useState, useContext } from 'react';
import { CurrencyContext } from '../context/CurrencyContext';
import './MortgageCalculator.css';

const MortgageCalculator = () => {
  const [principal, setPrincipal] = useState<number>(200000);
  const [interestRate, setInterestRate] = useState<number>(3.5);
  const [loanTerm, setLoanTerm] = useState<number>(30);
  const [monthlyPayment, setMonthlyPayment] = useState<number>(0);
  const [totalInterest, setTotalInterest] = useState<number>(0);
  const [totalPayment, setTotalPayment] = useState<number>(0);
  
  const { currencySymbol } = useContext(CurrencyContext);

  const calculateMortgage = (e: React.FormEvent) => {
    e.preventDefault();
    const monthlyRate = interestRate / 100 / 12;
    const numberOfPayments = loanTerm * 12;
    const monthlyPaymentAmount =
      (principal *
        monthlyRate *
        Math.pow(1 + monthlyRate, numberOfPayments)) /
      (Math.pow(1 + monthlyRate, numberOfPayments) - 1);
    
    // Calculate total payment and interest
    const totalPaymentAmount = monthlyPaymentAmount * numberOfPayments;
    const totalInterestAmount = totalPaymentAmount - principal;
    
    setMonthlyPayment(monthlyPaymentAmount);
    setTotalInterest(totalInterestAmount);
    setTotalPayment(totalPaymentAmount);
  };

  // Format currency for better readability
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div className="calculator">
      <h2>Mortgage Calculator</h2>
      <form onSubmit={calculateMortgage}>
        <div className="input-group">
          <label>Loan Amount ({currencySymbol})</label>
          <input
            type="number"
            value={principal}
            onChange={(e) => setPrincipal(Number(e.target.value))}
            min="0"
          />
        </div>
        <div className="input-group">
          <label>Annual Interest Rate (%)</label>
          <input
            type="number"
            value={interestRate}
            onChange={(e) => setInterestRate(Number(e.target.value))}
            min="0"
            step="0.1"
          />
        </div>
        <div className="input-group">
          <label>Loan Term (years)</label>
          <input
            type="number"
            value={loanTerm}
            onChange={(e) => setLoanTerm(Number(e.target.value))}
            min="0"
          />
        </div>
        <button type="submit">Calculate</button>
      </form>
      {monthlyPayment > 0 && (
        <div className="result">
          <h3>Monthly Payment</h3>
          <p>{currencySymbol}{formatCurrency(monthlyPayment)}</p>
          
          <div className="result-breakdown">
            <div className="result-item">
              <span className="result-item-label">Loan Amount:</span>
              <span className="result-item-value">{currencySymbol}{formatCurrency(principal)}</span>
            </div>
            <div className="result-item">
              <span className="result-item-label">Total Interest:</span>
              <span className="result-item-value">{currencySymbol}{formatCurrency(totalInterest)}</span>
            </div>
            <div className="result-item">
              <span className="result-item-label">Total Payment:</span>
              <span className="result-item-value">{currencySymbol}{formatCurrency(totalPayment)}</span>
            </div>
            <div className="result-item">
              <span className="result-item-label">Loan Term:</span>
              <span className="result-item-value">{loanTerm} years</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MortgageCalculator;
